import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	siteSurveysRestCrudThunksForBuyer,
	siteSurveysRestCrudThunksForSupplier,
} from '../../thunks/site_surveys_thunks';
import { goBackLink } from '../../utils/HistoryUtils';
import { withUserType } from '../withUserType';
import { getSSLocationsByTitleAndTemplate } from '../../thunks/site_surveys_grouped_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { message } from 'antd';
import SiteSurveyAddLocationForm from '../site_survey_form/SiteSurveyAddLocationForm';

const AddLocationToSiteSurveyPage: FC<any> = ({
	getSiteSurvey,
	getSiteSurveyLocations,
	siteSurvey,
	history,
	location,
	fetching,
	userType,
}): React.ReactElement => {
	const [locationLoading, setLocationsLoading] = useState(false);
	const [allLocations, setAllLocations] = useState([]);

	const { title: siteSurveyTitle, templateId: siteSurveyTemplateId } = useParams<{
		title: string;
		templateId: string;
	}>();
	const urlPath = `/${userType}/siteSurveys/byTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}/locations`;

	useEffect(() => {
		setLocationsLoading(true);
		getSiteSurveyLocations(siteSurveyTitle, siteSurveyTemplateId)
			.then((locations) => {
				setAllLocations(locations);
				if (nullSafeGet('0.siteSurveyId', locations)) {
					getSiteSurvey(nullSafeGet('0.siteSurveyId', locations));
				}
			})
			.catch(message.error)
			.finally(() => setLocationsLoading(false));
	}, [siteSurveyTemplateId, siteSurveyTitle]);

	return (
		<>
			<EditPage
				title="Add location to site survey"
				formComponentProps={{
					formData: {
						...siteSurvey,
						locationIds: allLocations.map((_) => _.locationId),
					},
					onSuccess: (rec) => {
						history.push(goBackLink(location, urlPath));
					},
				}}
				fetching={locationLoading || fetching}
				FormComponent={SiteSurveyAddLocationForm}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	siteSurvey: state.site_surveys.detail,
	siteSurveys: state['site_surveys/locationandwalkthrough'],
	fetching: state.site_surveys.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurvey: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveysRestCrudThunksForSupplier.readOne(id)
				: siteSurveysRestCrudThunksForBuyer.readOne(id)
		),
	getSiteSurveyLocations: (title, templateId) =>
		dispatch(getSSLocationsByTitleAndTemplate(ownProps.userType)(title, templateId)),
});

export default withUserType(
	withRouter(
		connect(mapStateToProps, mapDispatchToProps)(AddLocationToSiteSurveyPage as any)
	) as any
);
